import React, { useEffect, useState } from "react";
import BaseLayout from "../../components/BaseLayout";
import HeaderBaseLayout from "../../components/HeaderBaseLayout";
import EmptyData from "../../components/EmptyDataScreen";
import CardContent from "./CardContent";
import * as Assets from "../../utils/svg_assets";
import * as PageRoutes from "../../utils/route_pages";
import { Col } from "react-bootstrap";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { differenceDateUntilNow } from "../../utils/utilities";
import "./style.scss";

const PollingPage = (props) => {
  const navigate = useNavigate();
  const { getPollingList } = props;
  const [dataPolling, setDataPolling] = useState([]);

  const handleClickButton = (data) => {
    if (data?.is_completed) {
      navigate(PageRoutes.polling + `/${data.id}/result`);
    } else {
      navigate(PageRoutes.polling + `/${data.id}`);
    }
  };

  const getData = async () => {
    const { status, data } = await getPollingList();
    if (status == 200) {
      setDataPolling(data);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <BaseLayout
      isCustom={true}
      show_menu={false}
      header={
        <HeaderBaseLayout
          src={Assets.iconBackWhite}
          title="Polling"
          isCustomPicture={true}
          picture={`url(${
            process.env.PUBLIC_URL + "/SKOR-Polling-Header.png"
          })`}
          onClick={() => navigate(PageRoutes.home)}
        />
      }
    >
      <div className="polling-content">
        {dataPolling.length > 0 ? (
          dataPolling &&
          dataPolling.map((a, index) => (
            <Col xs={12} sm={12} md={12} className="content-wrapper">
              <CardContent
                key={index}
                title={a.name}
                points={a.points}
                currency={a.currency.name}
                likeCount={a.total_like}
                viewCount={a.total_view}
                commentCount={a.survey_comments.length}
                buttonText={a.is_completed ? "See Result" : "Vote Poll"}
                creator={a.creator}
                countDays={differenceDateUntilNow(a.start)}
                onClick={() => handleClickButton(a)}
              />
            </Col>
          ))
        ) : (
          <Col xs={12} sm={12} md={12} className="content-wrapper">
            <EmptyData
              title="There is no poll"
              image={`${process.env.PUBLIC_URL + "/SKOR-Quiz-NoQuiz.png"}`}
              imageStyle={{ width: "170px" }}
              bottomText="Stay tuned for more polls"
            />
          </Col>
        )}
      </div>
    </BaseLayout>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  getPollingList: dispatch.PollingSM.getPollingList,
});

export default connect(mapStateToProps, mapDispatchToProps)(PollingPage);
